declare namespace $ {

	export class $shm_hitalama_map_widget_view_dom extends $mol_view {
		dom_name( ): string
		content( ): any
	}
	
}

//# sourceMappingURL=dom.view.tree.d.ts.map